/**************
 Global
 ***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    // pixels
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (e) {
        // skip
    }

    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// quick add for collection cards
document.querySelectorAll('.collectionItemButton').forEach(button => {
    button.addEventListener('click', async function (e) {

        // prevent default
        e.preventDefault();

        // add loading animation
        this.classList.add("loading");

        // formdata
        let formdata = {
            quantity: 1,
            id: this.getAttribute('data-id')
        }

        // add product
        await addProduct(formdata);

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        await openCart();

    });
})

// dropdowns
document.querySelectorAll('.dropdown').forEach(dropdown => {
    dropdown.addEventListener('click', function () {
        if (this.classList.contains('active')) {
            this.classList.remove('active');
            return;
        }
        this.closest('.dropdownParent').querySelectorAll('.dropdown').forEach(dropdown => dropdown.classList.remove('active'));
        this.classList.add('active');
    });
})


// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID) {
    await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${await klaviyo.account()}`, {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantID}`,
                        }
                    }
                }
            }
        })
    })
}

// module klaviyo fire
async function soldOutVariant(productTitle, activeVariantTitle, activeVariantId) {
    // check email
    let {value: email} = await Swal.fire({
        title: `${productTitle} / ${activeVariantTitle}`,
        text: "Enter your email to be notified when this product is back in stock.",
        input: "email",
        inputPlaceholder: "Email Address",
        confirmButtonText: "Notify Me When Available",
    });

    // confirm email is returned
    if (!email) {
        return;
    }

    // add to waitlist
    await sendKlaviyoBackInStockRequest(email, activeVariantId);

    // show success message
    await Swal.fire({
        title: "Success!",
        text: "You will be notified when this product is back in stock.",
        confirmButtonText: "OK",
    });
}

function scrollUntilVisible(el) {
    const observer = new IntersectionObserver((entries, obs) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
            // double-check that it is fully rendered
            el.scrollIntoView({block: 'start', behavior: 'smooth'});
            obs.disconnect();
        } else {
            // nudge until it appears
            el.scrollIntoView({block: 'nearest'});
        }
    }, {
        threshold: 0.01, // triggers as soon as part of it shows up
        rootMargin: '0px'
    });

    observer.observe(el);
}